import React, {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  useContext,
  useReducer
} from 'react'
import reducer, { type PlayerState, INITIAL_STATE } from './reducer'
import { type PlayerActions } from './reducer/player.actions'

export const PlayerContext = createContext<{
  state?: PlayerState
  dispatch?: Dispatch<PlayerActions>
}>({})

const PlayerProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE)

  return (
    <PlayerContext.Provider value={{ state, dispatch }}>
      {children}
    </PlayerContext.Provider>
  )
}

export const usePlayerContext = () => {
  const context = useContext(PlayerContext)

  if (!context) {
    throw new Error('usePlayerContext must be used within a PlayerProvider')
  }

  return context
}

export const useCurrentAudio = () => {
  const { state: playerState } = usePlayerContext()

  return playerState.audioBooks.find(
    audioBook => audioBook.id === playerState.currentChapter.id
  )
}

export default PlayerProvider
